<template>
  <div :class="className">
    <div ref="line" class="sheet"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'sheet-line',
  props: {
    // "1":"机器业务" "2": "客户数量", "3": "机器清洁", "4": "账款", "5": "工单",6: "故障"
    lineType: {
      type: String,
      default: '1',
    },
    className: {
      type: String,
      default: 'line-wrapper',
    },
    lineData: {
      type: Array,
      default() {
        return [];
      },
    },
    item: {
      type: Object,
      default() {
        return {};
      },
    },
    isfull: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    maxLineDataValue() {
      // 遍历 lineData 数组，过滤每个对象中的 'time' 键
      const maxValue = this.lineData.reduce((max, item) => {
        // 过滤掉每个对象中的 'time' 键
        const filteredItem = Object.keys(item)
          .filter((key) => key !== 'time') // 过滤掉 'time' 键
          .reduce((obj, key) => {
            obj[key] = item[key]; // 将过滤后的键值重新组合成对象
            return obj;
          }, {});

        // 找到当前对象的最大值
        const currentMax = Math.max(...Object.values(filteredItem)); // 获取当前对象的最大值
        return currentMax > max ? currentMax : max; // 返回更大的值
      }, 0); // 初始最大值为 0

      // 如果最大值是 0，则返回 1，否则向上取整到最近的 10 的倍数
      // return maxValue === 0 ? 1 : Math.ceil(maxValue / 10) * 10;
      return maxValue === 0 ? 1 : Math.ceil(maxValue / 10 ** Math.floor(Math.log10(maxValue))) * 10 ** Math.floor(Math.log10(maxValue));
    },
    // minLineDataValue() {
    //   // 遍历 lineData 数组，过滤每个对象中的 'time' 键
    //   const minValue = this.lineData.reduce((min, item) => {
    //     // 过滤掉每个对象中的 'time' 键
    //     const filteredItem = Object.keys(item)
    //       .filter(key => key !== 'time') // 过滤掉 'time' 键
    //       .reduce((obj, key) => {
    //         obj[key] = item[key]; // 将过滤后的键值重新组合成对象
    //         return obj;
    //       }, {});

    //     // 找到当前对象的最小值
    //     const currentMin = Math.min(...Object.values(filteredItem)); // 获取当前对象的最小值
    //     return currentMin < min ? currentMin : min; // 返回更小的值
    //   }, Infinity); // 初始最小值为 Infinity

    //   // 如果最小值是 Infinity（意味着没有有效数据），则返回 1，否则向上取整到最近的 10 的倍数
    //   return minValue === Infinity ? 1 : Math.ceil(minValue / 10) * 10;
    // },
    // maxInterval() {
    //   return Math.ceil((this.maxLineDataValue - this.minLineDataValue) / 5);
    // },
    maxLineDataKey() {
      let maxKey = null;
      let maxValue = -Infinity;
      // 遍历所有对象
      this.lineData.forEach((item) => {
        // 遍历当前对象的键，排除 'time' 键
        Object.keys(item).forEach((key) => {
          if (key !== 'time' && item[key] > maxValue) {
            maxValue = item[key]; // 更新最大值
            maxKey = key; // 更新最大值对应的键
          }
        });
      });

      return maxKey; // 返回最大的键
    },
    maxLineDataEvent() {
      if (this.lineType !== '6') {
        return 0;
      }
      let maxValue = 0;
      // 遍历所有对象
      this.lineData.forEach((item) => {
        // 遍历当前对象的键，排除 'time' 键
        Object.keys(item).forEach((key) => {
          if (key === 'event' && item['event'] > maxValue) {
            maxValue = item[key]; // 更新最大值
          }
        });
      });
      return maxValue; // 返回最大的键
    },
    maxLineDataDevice() {
      if (this.lineType !== '6') {
        return 0;
      }
      let maxValue = 0;
      // 遍历所有对象
      this.lineData.forEach((item) => {
        // 遍历当前对象的键，排除 'time' 键
        Object.keys(item).forEach((key) => {
          if (key === 'device' && item['device'] > maxValue) {
            maxValue = item[key]; // 更新最大值
          }
        });
      });
      return maxValue; // 返回最大的键
    },
  },
  data() {
    return {
      lineProps: [],
      myChart: null,
      title: '',
      unit: '',
    };
  },
  watch: {
    lineData() {
      this.drawLine();
    },
    lineType() {
      this.drawLine();
    },
    isfull() {
      this.drawLine();
    },
  },
  mounted: function () {
    this.drawLine();
  },
  methods: {
    initProps() {
      // "1":"机器业务" "2": "客户数量", "3": "机器清洁", "4": "账款", "5": "工单"
      if (this.lineType === '1') {
        this.title = this.$t('base_line.ji_qi_ye_wu');
        this.unit = this.$t('base_line.tai');
        this.lineProps = [
          {
            name: this.$t('base_line.shi_yong'),
            code: 'trail',
            color: '#C6E6E3',
            type: 'line',
          },
          {
            name: this.$t('base_line.zu_lin'),
            code: 'lease',
            color: '#00A0D9',
            type: 'line',
          },
          {
            name: this.$t('base_line.shou_mai'),
            code: 'sales',
            color: '#B3B3B3',
            type: 'line',
          },
          {
            name: this.$t('base_line.wei_yue'),
            // icon: 'rect',
            code: 'breaks',
            color: '#EB5A5A',
            type: 'line',
          },
        ];
      } else if (this.lineType === '2') {
        this.title = this.$t('base_line.ke_hu');
        this.unit = this.$t('base_line.ge');
        this.lineProps = [
          {
            name: this.$t('base_line.ke_hu_shu'),
            code: 'customer',
            color: '#00A0D9',
            type: 'line',
          },
        ];
      } else if (this.lineType === '3') {
        this.title = this.$t('base_line.ji_qi_qing_jie');
        this.unit = this.$t('base_line.tai');
        this.lineProps = [
          {
            name: this.$t('base_line.ji_qi_shu'),
            code: 'total',
            color: '#202945',
            type: 'line',
          },
          {
            name: this.$t('base_line.qing_jie_ji_qi'),
            code: 'clean',
            color: '#93DA49',
            type: 'line',
          },
          {
            name: this.$t('base_line.shang_xian_ji_qi'),
            code: 'online',
            color: '#00A0D9',
            type: 'line',
          },
        ];
      } else if (this.lineType === '4') {
        this.title = this.$t('base_line.zhang_kuan');
        this.unit = '(¥)';
        this.lineProps = [
          {
            name: this.$t('base_line.ying_shou'),
            code: 'receivable',
            color: '#00A0D9',
            type: 'line',
          },
          {
            name: this.$t('base_line.yi_shou'),
            code: 'received',
            color: '#93DA49',
            type: 'line',
          },
          {
            name: this.$t('base_line.ying_fu'),
            code: 'payment',
            color: '#EB5A5A',
            type: 'line',
          },
          {
            name: this.$t('base_line.yi_fu'),
            code: 'paid',
            color: '#B3B3B3',
            type: 'line',
          },
        ];
      } else if (this.lineType === '5') {
        this.title = this.$t('base_line.gong_dan');
        this.unit = this.$t('base_line.dan');
        this.lineProps = [
          {
            name: this.$t('base_line.gong_dan_zong_shu'),
            code: 'total',
            color: '#202945',
            type: 'line',
          },
          {
            name: this.$t('Common.com_finish'),
            code: 'finish',
            color: '#93DA49',
            type: 'line',
          },
          {
            name: this.$t('base_line.chao_shi'),
            code: 'over',
            color: '#EB5A5A',
            type: 'line',
          },
          {
            name: this.$t('base_line.wei_jie_jue'),
            code: 'unsolved',
            color: '#B3B3B3',
            type: 'line',
          },
          {
            name: this.$t('base_line.gong_cheng_shi_shu'),
            code: 'technician',
            color: '#00A0D9',
            type: 'bar',
          },
        ];
      } else if (this.lineType === '6') {
        this.title = '';
        this.unit = '';
        this.lineProps = [
          {
            code: 'event',
            color: '#00A0D9',
            type: 'bar',
          },
          {
            code: 'device',
            color: '#93DA49',
            type: 'line',
          },
        ];
      }
    },

    drawLine() {
      this.initProps();
      if (this.myChart) {
        this.myChart.dispose();
      }
      // 基于准备好的dom，初始化echarts实例
      // this.myChart = this.$echarts.init(this.$refs.line);
      this.myChart = echarts.init(this.$refs.line);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
      // 绘制图表
      this.myChart.setOption({
        // tooltip: {
        //   show: true
        // },

        tooltip: {
          // trigger: 'none',
          axisPointer: {
            // show: this.lineType !== '6',
            type: 'none',
          },
          trigger: 'axis',
          // 启用提示框
          show: true,

          padding:
            this.lineType === '6'
              ? [
                0, // 上
                2, // 右
                0, // 下
                2, // 左
              ]
              : null,
          textStyle:
            this.lineType === '6'
              ? {
                fontSize: 12,
                lineHeight: 12,
                height: 12,
              }
              : null,
          // 相对位置
          position: this.lineType === '6' ? ['42%', '0%'] : null,
          // position: [10, 0],
          formatter:
            this.lineType === '6'
              ? function (params) {
                var result = '';
                var bar = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00A0D9"></span>';
                var line = '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#93DA49"></span>';
                if (Array.isArray(params)) {
                  params.forEach((item, i) => {
                    result += ` ${i === 0 ? `${item.axisValue}</br>` : ''} ${i === 0 ? bar : line}${item.data} `;
                  });
                  // result += `${bar} ${params.data} ${line} ${params.data} `;
                }
                return result;
              }
              : null,
        },
        title:
          this.lineType === '6'
            ? null
            : {
              text: this.title,
              left: 0,
              top: 0,
              textStyle: {
                fontSize: 12,
                lineHeight: 32,
                color: '#4D4D4D',
                fontWeight: 'bold',
              },
            },
        graphic:
          this.lineType === '6'
            ? [
              {
                type: 'text',
                left: 'left', // 左上角
                top: 'top',
                style: {
                  text: this.maxLineDataEvent,
                  textAlign: 'center',
                  textVerticalAlign: 'middle',
                  font: '16px',
                  fill: '#00A0D9',
                },
              },
              {
                type: 'text',
                left: 'right', // 右上角
                top: 'top',
                style: {
                  text: this.maxLineDataDevice,
                  textAlign: 'center',
                  textVerticalAlign: 'middle',
                  font: '16px',
                  fill: '#93DA49',
                },
              },
            ]
            : [],
        grid:
          this.lineType === '6'
            ? {
              left: 20,
              right: 20,
              top: 0, // y1表示dataZoom与Y轴的距离
              bottom: 0, // y2表示dataZoom与X轴的距离
            }
            : {
              left: 60,
              right: 0,
              top: 87, // y1表示dataZoom与Y轴的距离
              bottom: 50, // y2表示dataZoom与X轴的距离
            },

        legend:
          this.lineType === '6'
            ? null
            : {
              top: 48,
              textStyle: {
                color: '#1A1A1A',
                fontSize: 12,
                lineHeight: 24,
              },
            },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          axisLine: {
            show: this.lineType !== '6',
            lineStyle: { color: '#E6E6E6' },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: this.lineType !== '6',
            margin: 10,
            fontSize: 12,
            fontWeight: 400,
            color: '#4D4D4D',
          },
          // splitLine: {
          //   show: false,
          // },
          axisPointer: {
            show: true,
            // show: this.lineType !== '6',
            type: 'none',
          },
          data: this.lineData.map((t) => t.time),
        },

        yAxis: this.lineProps.map((t) => ({
          type: 'value',
          scale: true,
          // i === 0,
          show: t.code === this.maxLineDataKey && this.lineType !== '6',
          // splitNumber: 6,
          name: this.unit,
          position: 'left',
          // offset: i === 0 ? 0 : 80,
          nameGap: 10,
          // nameLocation: 'start',
          nameTruncate: {
            maxWidth: 90,
            ellipsis: '...',
          },
          nameTextStyle: {
            color: '#818181',
            fontSize: 12,
            lineHeight: 20,
            fontWeight: 400,
            // align: 'center',
            // align: i === 0 ? 'left' : 'right',
            padding: [0, 40, 0, 0],
          },
          axisLine: {
            show: false,
            lineStyle: { color: '#EEEEEE' },
          },
          axisLabel: {
            margin: 10,
            fontSize: 12,
            fontWeight: 400,
            color: '#4D4D4D',

            formatter: (value) => {
              // 判断是否为整数并需要格式化
              if (value >= 1000) {
                const formattedValue = (value / 1000).toFixed(1);
                return formattedValue.endsWith('.0') ? `${parseInt(formattedValue, 10)}k` : `${formattedValue}k`;
              } else {
                return value;
              }
            },
          },
          splitLine: {
            show: t.code === this.maxLineDataKey && this.lineType !== '6',
            lineStyle: { color: '#EEEEEE' },
          },
          // splitNumber: 6,
          minInterval: this.lineType !== '6' ? 1 : 2,
          min: this.lineType !== '6' ? 0 : 1,
          // maxInterval: this.maxLineDataValue,
          max: this.lineType !== '6' ? this.maxLineDataValue : null,
          // interval: this.minLineDataValue > 0 ? null : this.maxInterval
        })),
        // dataZoom: this.lineData.length <= 12 || this.lineType === '6' ? null : [
        //   {
        //     type: 'slider',
        //     start: 0,
        //     end: parseInt(1200 / this.lineData.length, 10), // 以12为一份
        //     height: '15px', // 高度设置，另外还有宽度
        //     width: '100%'
        //   }
        // ],
        series: this.lineProps.map((t, i) => ({
          name: t.name,
          // 只有机器-业务为空要断开
          data: this.lineType === '1' ? this.lineData.map((f) => f[t.code]).map((item) => (item === 0 ? '' : item)) : this.lineData.map((f) => f[t.code]),
          // barWidth: '30%',
          type: t.type,
          yAxisIndex: i,
          barWidth: t.type === 'bar' ? '17' : null,
          lineStyle: {
            color: t.color,
            with: 3,
          },
          symbol: 'circle',
          symbolSize: 8,
          // symbol: ,
          legendHoverLink: false,
          itemStyle: {
            color: t.type === 'line' && this.lineType === '6' ? 'transparent' : t.color,
            borderColor: t.type === 'line' && this.lineType === '6' ? 'transparent' : '#ffffff',
            borderWidth: 2,
            borderType: 'solid',
          },
        })),
      });
      // 监听点击事件
      if (this.lineType === '6') {
        this.myChart.on('click', (params) => {
          if (params.seriesType === 'line') {
            this.$emit('clickLine', this.item, this.$getDayRange(params.name));
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.line-wrapper,
.workorder-sheet,
.fault-sheet {
  height: 292px;
  position: relative;
  .sheet {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
}
.workorder-sheet {
  height: 300px;
}
.fault-sheet {
  height: 40px;
  width: 100%;
  margin-right: 16px;
}
</style>
